import script from "./Bsu.vue?vue&type=script&setup=true&lang=js"
export * from "./Bsu.vue?vue&type=script&setup=true&lang=js"

import "./Bsu.vue?vue&type=style&index=0&id=72f17d78&lang=css"

const __exports__ = script;

export default __exports__